<template>
  <div class="group-management-button">
    <b-dropdown
      class="group-management-button__dropdown no-internal-print"
      split
      :popper-opts="this.popperOptions"
      variant="outline-primary"
      :text="$t('engineering.cooling-maintenance.inform-maintenance')"
      @click="openManagementModal(modalTypes.MAINTENANCE)"
    >
      <b-dropdown-item
        @click="openManagementModal(modalTypes.REPLACEMENT)"
      >
        <b-btn
          class="my-sm-0"
          variant="outline-primary"
          block
        >
          {{ $t('engineering.cooling-maintenance.replace-group') }}
        </b-btn>
      </b-dropdown-item>
    </b-dropdown>
    <group-management-modal
      v-model="showModal"
      :modal-type="selectedModalType"
      @refresh="$emit('refresh')"
    />
  </div>
</template>

<script>
import GroupManagementModal from '@/domain/components/installation/engineering/coolingMaintenance/general/modal/GroupManagementModal';
import modalTypes from '@/domain/enums/installation/engineering/coolingMaintenance/groupManagementModalTypes';
import popperOptsMixin from '@/services/popperOptsMixin';

export default {
  name: 'GroupManagementButton',
  components: { GroupManagementModal },
  mixins: [popperOptsMixin],
  data: () => ({
    modalTypes,
    selectedModalType: null,
    showModal: false,
  }),
  methods: {
    openManagementModal(modalType) {
      this.selectedModalType = modalType;
      this.showModal = true;
    },
  },
};
</script>

<style lang="sass" scoped>
  .group-management-button
    &__dropdown ::v-deep
      .dropdown-menu.show,
      .dropdown-item
        padding: 0
        width: 100%
</style>
